import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="recipient-selector"
export default class extends Controller {
  static targets = ["customersRadio", "buildingsRadio", "customerContainer", "buildingContainer", "customerField", "buildingField"]

  connect() {
    console.log('Recipient selector controller connected')
    console.log('Available targets:', {
      customersRadio: this.hasCustomersRadioTarget,
      buildingsRadio: this.hasBuildingsRadioTarget,
      customerContainer: this.hasCustomerContainerTarget,
      buildingContainer: this.hasBuildingContainerTarget,
      customerField: this.hasCustomerFieldTarget,
      buildingField: this.hasBuildingFieldTarget
    })
    
    // Initialize form confirmation flag
    this.confirmationShown = false

    // Add explicit event listeners to radio buttons
    if (this.hasCustomersRadioTarget) {
      this.customersRadioTarget.addEventListener('change', this.handleRadioChange.bind(this))
      console.log('Added listener to customers radio')
    }
    if (this.hasBuildingsRadioTarget) {
      this.buildingsRadioTarget.addEventListener('change', this.handleRadioChange.bind(this))
      console.log('Added listener to buildings radio')
    }
    
    this.setInitialVisibility()
  }

  setInitialVisibility() {
    console.log('Setting initial visibility')
    const customersChecked = this.hasCustomersRadioTarget && this.customersRadioTarget.checked
    const buildingsChecked = this.hasBuildingsRadioTarget && this.buildingsRadioTarget.checked
    
    console.log('Customers checked:', customersChecked)
    console.log('Buildings checked:', buildingsChecked)
    
    if (buildingsChecked) {
      this.showBuildingSelection()
    } else {
      this.showCustomerSelection()
    }
  }

  handleRadioChange(event) {
    console.log('Radio button changed to:', event.target.value)
    
    if (event.target.value === 'customers') {
      this.showCustomerSelection()
    } else if (event.target.value === 'buildings') {
      this.showBuildingSelection()
    }
  }

  showCustomerSelection() {
    console.log('Showing customer selection')
    if (this.hasCustomerContainerTarget) {
      this.customerContainerTarget.style.display = 'block'
    }
    if (this.hasBuildingContainerTarget) {
      this.buildingContainerTarget.style.display = 'none'
    }

    // Enable customer field and disable building field
    this.enableField('customerField')
    this.disableField('buildingField')
  }

  showBuildingSelection() {
    console.log('Showing building selection')
    if (this.hasCustomerContainerTarget) {
      this.customerContainerTarget.style.display = 'none'
    }
    if (this.hasBuildingContainerTarget) {
      this.buildingContainerTarget.style.display = 'block'
    }

    // Enable building field and disable customer field
    this.enableField('buildingField')
    this.disableField('customerField')
  }

  enableField(fieldTargetName) {
    const target = this[`${fieldTargetName}Target`]
    if (target) {
      console.log(`Enabling ${fieldTargetName}`)
      target.disabled = false

      // Also enable the Selectize control if it exists
      const selectizeControl = target.parentElement.querySelector('.selectize-control')
      if (selectizeControl) {
        selectizeControl.classList.remove('selectize-disabled')
        const selectizeInput = selectizeControl.querySelector('.selectize-input')
        if (selectizeInput) {
          selectizeInput.classList.remove('disabled')
        }

        // Also try to access the selectize instance and enable it
        if (target.selectize) {
          target.selectize.enable()
        }
      }
    }
  }

  disableField(fieldTargetName) {
    const target = this[`${fieldTargetName}Target`]
    if (target) {
      console.log(`Disabling ${fieldTargetName}`)
      target.disabled = true

      // Clear any selected values first
      if (target.selectize) {
        target.selectize.clear()
        target.selectize.disable()
      }

      // If disabling customer field, also clear quick selection chips
      if (fieldTargetName === 'customerField') {
        this.clearCustomerQuickSelections()
      }
    }
  }

  clearCustomerQuickSelections() {
    // Find the customer-select controller and clear quick selections
    const customerContainer = document.querySelector('[data-controller*="customer-select"]')
    if (customerContainer) {
      const customerSelectController = this.application.getControllerForElementAndIdentifier(customerContainer, 'customer-select')
      if (customerSelectController && customerSelectController.clearAllSelections) {
        console.log('Clearing customer quick selections when switching to buildings')
        customerSelectController.clearAllSelections()
      }
    }
  }

  handleFormSubmit(event) {
    // If confirmation was already shown and accepted, allow submission
    if (this.confirmationShown) {
      this.confirmationShown = false
      return true
    }

    const recipientCount = this.getRecipientCount()
    const shouldShow = recipientCount >= 2

    // Check if we should show confirmation popup
    if (!shouldShow) {
      return true
    }

    // Prevent default submission to show confirmation
    event.preventDefault()

    const confirmationMessage = this.buildConfirmationMessage(recipientCount)

    if (confirm(confirmationMessage)) {
      this.confirmationShown = true
      // Trigger form submission
      event.target.submit()
    } else {
      // User cancelled - re-enable the submit button
      this.reenableSubmitButton()
    }
  }

  reenableSubmitButton() {
    // Find the submit button and re-enable it
    const submitButton = document.querySelector('input[type="submit"]')
    if (submitButton) {
      // Use setTimeout to ensure this runs after Rails UJS processing
      setTimeout(() => {
        submitButton.disabled = false
      }, 100)
    }
  }

  getRecipientCount() {
    // Check customer counter
    const customerCounter = document.querySelector('[data-customer-select-target="counter"]')
    if (customerCounter) {
      const customerCount = parseInt(customerCounter.textContent.trim()) || 0
      if (customerCount > 0) {
        return customerCount
      }
    }

    // Check building counter
    const buildingCounter = document.querySelector('[data-building-select-target="recipientCounter"]')
    if (buildingCounter) {
      const buildingCount = parseInt(buildingCounter.textContent.trim()) || 0
      if (buildingCount > 0) {
        return buildingCount
      }
    }

    return 0
  }

  buildConfirmationMessage(recipientCount) {
    const replyDisabled = document.getElementById('support_ticket_reply_disabled').checked
    if (replyDisabled) {
      return `Olet lähettämässä tiedotteen ${recipientCount} asiakkaalle. Tiedotteeseen ei voi vastata. Oletko varma?`
    } else {
      return `Olet lähettämässä viestin ${recipientCount} asiakkaalle. Viestiin VOI vastata. Oletko varma?`
    }
  }
}
